import { Dialog, DialogContent, DialogActions, Box } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import { ButtonComp } from 'shared/components/AppComponents';
import { ReactElement } from 'react';
import {
    DialogFileBoxDialog,
    DialogFileBoxDialogAction,
    DialogFileBoxStepDialog,
    DialogFileBoxText,
    DialogFileDialogFiles,
} from 'assets/styles/modules/upload-documents/upload-packet/DialogFile';

/**
 * Represents the DialogFileUpload component.
 *
 * @param {DialogFileUploadProps} props - The component props.
 * @returns {ReactElement} - The rendered component.
 */
const DialogFileUpload = ({
    openDialogFile,
    setOpenDialogFile,
    confirmation,
}: DialogFormUpload): ReactElement => {
    // Actions
    const actionPositive = (): void => {
        confirmation(false, true);
    };
    const actionNegative = (): void => {
        setOpenDialogFile(false);
    };

    return (
        <Box>
            <Dialog
                open={openDialogFile}
                onClose={() => setOpenDialogFile(false)}
                maxWidth="md"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '39rem',
                    },
                }}
            >
                <DialogContent dividers sx={DialogFileDialogFiles}>
                    <Box sx={{ padding: '1rem 0' }}>
                        <Box sx={DialogFileBoxDialog}>
                            <TypographyLevel variant="two">
                                <Box>Please DO NOT close your browser</Box>
                                <Box>until all files had been uploaded</Box>
                            </TypographyLevel>
                        </Box>

                        <Box sx={DialogFileBoxStepDialog}>
                            <TypographyLevel variant="four">
                                <Box sx={DialogFileBoxText}>
                                    Otherwise will cancel your upload
                                </Box>
                            </TypographyLevel>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions className="DialogFile-DialogAction">
                    <Box sx={DialogFileBoxDialogAction}>
                        {/* ACTION SHORTCUT  */}
                        {/* Action Negative - False */}
                        <ButtonComp
                            width="16rem"
                            onClick={() => actionNegative()}
                            type="neutral"
                        >
                            Go back & Edit
                        </ButtonComp>

                        {/* Action Positive - True */}
                        <ButtonComp
                            width="16rem"
                            onClick={() => actionPositive()}
                            type="primary"
                        >
                            Confirm & Proceed
                        </ButtonComp>
                    </Box>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default DialogFileUpload;
